/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateOrganizationRequestLegalInfo } from './CreateOrganizationRequestLegalInfo';
import {
    CreateOrganizationRequestLegalInfoFromJSON,
    CreateOrganizationRequestLegalInfoFromJSONTyped,
    CreateOrganizationRequestLegalInfoToJSON,
    CreateOrganizationRequestLegalInfoToJSONTyped,
} from './CreateOrganizationRequestLegalInfo';
import type { CreateOrganizationRequestSubscription } from './CreateOrganizationRequestSubscription';
import {
    CreateOrganizationRequestSubscriptionFromJSON,
    CreateOrganizationRequestSubscriptionFromJSONTyped,
    CreateOrganizationRequestSubscriptionToJSON,
    CreateOrganizationRequestSubscriptionToJSONTyped,
} from './CreateOrganizationRequestSubscription';

/**
 * 
 * @export
 * @interface CreateOrganizationRequest
 */
export interface CreateOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    number?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateOrganizationRequest
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof CreateOrganizationRequest
     */
    longitude: number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    postalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    regionCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    provinceCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    neighborhood?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    province?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrganizationRequest
     */
    leadId?: string;
    /**
     * 
     * @type {CreateOrganizationRequestLegalInfo}
     * @memberof CreateOrganizationRequest
     */
    legalInfo: CreateOrganizationRequestLegalInfo;
    /**
     * 
     * @type {CreateOrganizationRequestSubscription}
     * @memberof CreateOrganizationRequest
     */
    subscription: CreateOrganizationRequestSubscription;
}

/**
 * Check if a given object implements the CreateOrganizationRequest interface.
 */
export function instanceOfCreateOrganizationRequest(value: object): value is CreateOrganizationRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    if (!('regionCode' in value) || value['regionCode'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('legalInfo' in value) || value['legalInfo'] === undefined) return false;
    if (!('subscription' in value) || value['subscription'] === undefined) return false;
    return true;
}

export function CreateOrganizationRequestFromJSON(json: any): CreateOrganizationRequest {
    return CreateOrganizationRequestFromJSONTyped(json, false);
}

export function CreateOrganizationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrganizationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'address': json['address'],
        'street': json['street'] == null ? undefined : json['street'],
        'number': json['number'] == null ? undefined : json['number'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'regionCode': json['regionCode'],
        'countryCode': json['countryCode'],
        'provinceCode': json['provinceCode'] == null ? undefined : json['provinceCode'],
        'neighborhood': json['neighborhood'] == null ? undefined : json['neighborhood'],
        'city': json['city'] == null ? undefined : json['city'],
        'province': json['province'] == null ? undefined : json['province'],
        'country': json['country'] == null ? undefined : json['country'],
        'email': json['email'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
        'leadId': json['leadId'] == null ? undefined : json['leadId'],
        'legalInfo': CreateOrganizationRequestLegalInfoFromJSON(json['legalInfo']),
        'subscription': CreateOrganizationRequestSubscriptionFromJSON(json['subscription']),
    };
}

export function CreateOrganizationRequestToJSON(json: any): CreateOrganizationRequest {
    return CreateOrganizationRequestToJSONTyped(json, false);
}

export function CreateOrganizationRequestToJSONTyped(value?: CreateOrganizationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'address': value['address'],
        'street': value['street'],
        'number': value['number'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'postalCode': value['postalCode'],
        'regionCode': value['regionCode'],
        'countryCode': value['countryCode'],
        'provinceCode': value['provinceCode'],
        'neighborhood': value['neighborhood'],
        'city': value['city'],
        'province': value['province'],
        'country': value['country'],
        'email': value['email'],
        'phoneNumber': value['phoneNumber'],
        'leadId': value['leadId'],
        'legalInfo': CreateOrganizationRequestLegalInfoToJSON(value['legalInfo']),
        'subscription': CreateOrganizationRequestSubscriptionToJSON(value['subscription']),
    };
}

